import { Component, Input } from '@angular/core';

@Component({
	selector: 'rpshared-mat-loading-card',
	styleUrls: ['./mat-loading-card.component.scss'],
	templateUrl: './mat-loading-card.component.html',
})
export class MatLoadingCardComponent {
	@Input() isLoading = false;
	@Input() icon: string;
	@Input() title: string;
}
